export const currencyConst = {
  lebanesePound: 'LYD'
};
